// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITaxFormMailingCreateDto
 */
export interface ITaxFormMailingCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ITaxFormMailingCreateDto
     */
    tax_form_id: number;
    /**
     * 
     * @type {string}
     * @memberof ITaxFormMailingCreateDto
     */
    form_type: ITaxFormMailingCreateDtoFormTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ITaxFormMailingCreateDtoFormTypeEnum {
    TAX_FORM_1099 = 'TAX_FORM_1099',
    TAX_FORM_5498 = 'TAX_FORM_5498',
    TAX_FORM_EXCESS_1099 = 'TAX_FORM_EXCESS_1099'
}


/**
 * Check if a given object implements the ITaxFormMailingCreateDto interface.
 */
export function instanceOfITaxFormMailingCreateDto(value: object): value is ITaxFormMailingCreateDto {
    if (!('tax_form_id' in value) || value['tax_form_id'] === undefined) return false;
    if (!('form_type' in value) || value['form_type'] === undefined) return false;
    return true;
}

export function ITaxFormMailingCreateDtoFromJSON(json: any): ITaxFormMailingCreateDto {
    return ITaxFormMailingCreateDtoFromJSONTyped(json, false);
}

export function ITaxFormMailingCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITaxFormMailingCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tax_form_id': json['tax_form_id'],
        'form_type': json['form_type'],
    };
}

export function ITaxFormMailingCreateDtoToJSON(json: any): ITaxFormMailingCreateDto {
    return ITaxFormMailingCreateDtoToJSONTyped(json, false);
}

export function ITaxFormMailingCreateDtoToJSONTyped(value?: ITaxFormMailingCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tax_form_id': value['tax_form_id'],
        'form_type': value['form_type'],
    };
}

